export default "__VITE_ASSET__CiafPDPC__"